import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * BackButton - Shows a back navigation button on non-root pages
 * Integrates with browser history for natural navigation
 */
export function BackButton() {
    const navigate = useNavigate();
    const location = useLocation();

    // Root pages where we don't show the back button
    const rootPages = ["/admin", "/instructor", "/learner"];
    const isRootPage = rootPages.includes(location.pathname);

    // Don't show on dashboard/root pages
    if (isRootPage) return null;

    return (
        <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="mb-4 gap-2 text-muted-foreground hover:text-foreground transition-colors"
        >
            <ArrowLeft size={16} />
            Back
        </Button>
    );
}

export default BackButton;
